import { isSaasDistribution } from "utils/distribution";

import useTypedFlags from "./useTypedFlags";

const useIsOnboardingCertificatesAvailable = () => {
  const { onboardingCertificates } = useTypedFlags();

  return onboardingCertificates && isSaasDistribution();
};

export default useIsOnboardingCertificatesAvailable;
